import React from 'react';

// Import necessary components
import { Lightbox, PageSidebar, PageTitle } from '../../../components';

// Import icons for visual representation
import { FaCaretRight, FaCheck, FaCircleNotch } from 'react-icons/fa';

// Import useLocation to access route state
import { useLocation } from 'react-router-dom';



const WindowSingle = () => {

  // Get Window details passed via router state
  const location = useLocation();
  const window = location.state;

  return (
    <>
      {/* Page Title Section */}
      <PageTitle title={window.title} page={"Window Single"} />

      <section className='window-single page-single'>

        <div className='window-info page-info'>

          {/* Window Image */}
          <div className='image'>
            <img src={window.image} alt={window.title} />
          </div>

          <div className='content'>

            {/* Window Title */}
            <h3 className='main-heading'>{window.title}</h3>

            {/* Window Description */}
            {window.paragraphs.map((paragraph, index) => (
              <p key={index} className={index === 0 ? 'important' : ''}>
                {paragraph}
              </p>
            ))}

            {/* Window Image Gallery */}
            <Lightbox images={window.gallery} />

            {/* Design and Style */}
            <div className='sub-section'>

              <h3 className='sub-heading'>Design and Style:</h3>
              <p>{window.title} is crafted to complement your home's architecture with modern design and customizable style options:</p>

              {/* List of Styles */}
              <ul>
                {window.styles.map((style, index) => {
                  return <li key={index}>
                    <div className='icon'><FaCheck /></div>
                    {style}
                  </li>
                })}
              </ul>

            </div>

            {/* Features and Benefits */}
            <div className='sub-section'>

              <h3 className='sub-heading'>Features and Benefits:</h3>
              <p>{window.title} offers enhanced functionality, security, and aesthetic appeal to elevate your living space:</p>

              {/*Features List */}
              <ul>
                {window.features.map((feature, index) => {
                  return <li key={index}>
                    <div className='icon'><FaCaretRight /></div>
                    {feature}
                  </li>
                })}
              </ul>

            </div>

            {/* Specifications */}
            <div className='sub-section'>

              <h3 className='sub-heading'>Specifications:</h3>
              <p>A detailed overview of the dimensions, materials, and performance standards of the {window.title}:</p>

              {/* Specifications List */}
              <ul>
                {window.specifications.map((specification, index) => {
                  return <li key={index}>
                    <div className='icon'><FaCircleNotch /></div>
                    {specification}
                  </li>
                })}
              </ul>

            </div>

          </div>

        </div>

        {/* Sidebar with Window details */}
        <PageSidebar
          heading={'Window'}
          details={window.details}
        />

      </section>

    </>
  );
}

export default WindowSingle;